module.exports = __webpack_public_path__ + "static/media/logout.2716957a.svg";